import { CommonModule } from '@angular/common';
import { Component, Input, Output, type OnInit, EventEmitter } from '@angular/core';
import { Occurrence } from '../../../../../shared/src/lib/model/occurrence.model';
import { environment } from '../../../../../environments/environment';
import { OccurrenceService } from '../../../../../shared/src/lib/service/occurrence.service';
import { MaterialService } from '../../../../../shared/src/lib/service/material.service';

@Component({
    selector: 'app-reschedule-request',
    templateUrl: './reschedule-request.component.html',
    styleUrls: ['./reschedule-request.component.scss']
})
export class RescheduleRequestComponent implements OnInit {
    @Input() occurrence: Occurrence;
    @Output() getRescheduleRequested = new EventEmitter<void>();

    defaultAvatar = environment.static + '/avatar.png';
    reasonChoices: {
        code: string;
        label: string;
    }[];
    loading = false;

    constructor(
        private occurrenceService: OccurrenceService,
        private materialService: MaterialService
    ) {

    }

    ngOnInit(): void {
        this.reasonChoices = this.occurrenceService.getCancelledReasonChoice();
    }

    setRecheduleRequest(status: "accepted" | "refused") {
        // Une seule décision par demande : un second clic pendant l'envoi est ignoré.
        if (this.loading) {
            return;
        }
        this.loading = true;
        this.occurrenceService.setRecheduleRequest(this.occurrence.id, status).subscribe(
            () => {
                this.getRescheduleRequested.emit();
                this.loading = false;
                if (status === 'accepted') {
                    this.materialService.openSnackBar("Merci d'avoir accèpté le report", 'green')
                }
                if (status === 'refused') {
                    this.materialService.openSnackBar("Merci d'avoir répondu au report", 'green')

                }
            },
            (error) => {
                this.loading = false;
                if (error.status === 409) {
                    // Déjà acceptée ou refusée (autre onglet, double envoi) : la liste est rechargée.
                    this.materialService.openSnackBar('This request has already been answered', 'orange');
                    this.getRescheduleRequested.emit();
                } else {
                    this.materialService.openSnackBar('Error, please try again', 'red');
                }
            }
        )
    }

    getLabelByCode(code: string): string {
        const reason = this.reasonChoices.find(r => r.code === code);
        return reason ? reason.label : '';
    }

}
